import TakerResults from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/TakerResults/TakerResults";

export default TakerResults;
